module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/report_01-1ba6da4b1a289fef92dddb14e2c56370.png";